<div class="zoom-panel" data-tour="step12">
  <button mat-icon-button (click)="resetZoom() " matTooltip="Ansicht zurücksetzen">
    <mat-icon>fullscreen_exit</mat-icon>
  </button>
  <button mat-icon-button (click)="zoomOut()" matTooltip="Verkleinern">
    <mat-icon>remove</mat-icon>
  </button>
  <span class="zoom-label">{{ zoomLevel }}%</span>
  <button mat-icon-button (click)="zoomIn()" matTooltip="Vergrößern">
    <mat-icon>add</mat-icon>
  </button>
</div>
